const fullRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/service-provider:visit',
  '/service-provider/my-profile:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',

  '/service-provider/reports:visit',
  '/service-provider/reports/requirements:visit',
  // '/service-provider/reports/create:visit',
  '/service-provider/reports/create-link:visit',
  '/service-provider/reports/create-report:visit',
  '/service-provider/reports/:reportId:visit',
  '/service-provider/reports/templates:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/templates/:templateId:visit',

  '/service-provider/programmes/portfolios:visit',
  '/service-provider/programmes/:programmeId/sites:visit',
  '/service-provider/programmes/:programmeId/sites/hierarchies:visit',
  '/service-provider/programmes/:programmeId/sites/hierarchies/:hierarchyId:visit',
  '/service-provider/programmes/:programmeId/sites/hierarchies/create:visit',
  '/service-provider/programmes/:programmeId/sites/services:visit',
  '/service-provider/programmes/:programmeId/sites/services/:serviceId:visit',
  '/service-provider/programmes/:programmeId/sites/services/create:visit',
  '/service-provider/programmes/:programmeId/reporters:visit',
  '/service-provider/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/service-provider/programmes:visit',
  '/service-provider/programmes/create:visit',
  '/service-provider/programmes/:programmeId/overview:visit',
  '/service-provider/programmes/:programmeId/indicators:visit',
  '/service-provider/programmes/:programmeId/monitoring:visit',
  '/service-provider/programmes/:programmeId/complete:visit',
  '/service-provider/programmes/interventions:visit',
  '/service-provider/programmes/interventions/create:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/create:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions/cohorts:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/create:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/:cohortId:visit',
  '/service-provider/programmes/interventions/:interventionId/overview:visit',
  '/service-provider/programmes/interventions/:interventionId/indicators:visit',
  '/service-provider/programmes/interventions/:interventionId/inputs:visit',
  '/service-provider/programmes/interventions/:interventionId/activities:visit',
  '/service-provider/programmes/interventions/:interventionId/monitoring:visit',
  '/service-provider/programmes/interventions/:interventionId/complete:visit',
  '/service-provider/programmes/interventions/:interventionId/reporters:visit',
  '/service-provider/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',

  '/service-provider/exports:visit',
  '/service-provider/exports/:workspaceId/questions:visit',
  '/service-provider/exports/:workspaceId/questions/:type/:typeId:visit',
  '/service-provider/exports/profile-data:visit',
  '/service-provider/exports/programme-stats:visit',
  '/service-provider/exports/school-data:visit',

  '/service-provider/manage:visit',
  '/service-provider/manage/insights:visit',
  '/service-provider/manage/insights/:insightId:visit',
  '/service-provider/manage/insights/:insightId/users:visit',
  '/service-provider/manage/insights/create-new:visit',
  '/service-provider/manage/institutions:visit',
  '/service-provider/manage/institutions/sites:visit',
  '/service-provider/manage/institutions/sites/hierarchies:visit',
  '/service-provider/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/service-provider/manage/institutions/sites/hierarchies/create:visit',
  '/service-provider/manage/institutions/sites/services:visit',
  '/service-provider/manage/institutions/sites/services/:serviceId:visit',
  '/service-provider/manage/institutions/sites/services/create:visit',
  '/service-provider/manage/institutions/create:visit',
  '/service-provider/manage/institutions/:institutionId:visit',
  '/service-provider/manage/institutions/cohorts:visit',
  '/service-provider/manage/institutions/cohorts/create:visit',
  '/service-provider/manage/institutions/cohorts/:cohortId:visit',
  '/service-provider/manage/institutions/registrations:visit',
  '/service-provider/manage/institutions/registrations/archived:visit',
  '/service-provider/manage/institutions/registrations/create:visit',
  '/service-provider/manage/institutions/registrations/:institutionId:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/service-details:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/service-contacts:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registration-management:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registrations:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registrations/register:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/application:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/framework:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/assessment:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/complete:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/approve:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/people:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/people/create:visit',
  '/service-provider/manage/institutions/registrations/:institutionId/people/:personId:visit',

  '/service-provider/manage/people:visit',
  '/service-provider/manage/people/create:visit',
  '/service-provider/manage/people/:personId:visit',
  '/service-provider/manage/people/addnew:visit',
  '/service-provider/manage/people/cohorts:visit',
  '/service-provider/manage/people/cohorts/create:visit',
  '/service-provider/manage/people/cohorts/:cohortId:visit',

  '/service-provider/my-activities:visit',
  '/service-provider/my-activities/:activityId/sessions/:visit',
  '/service-provider/my-activities/:activityId/sessions/create:visit',
  '/service-provider/my-activities/:activityId/sessions/:sessionId:visit',
  '/service-provider/my-activities/:activityId/attendees/:visit',
  '/service-provider/activities/:stakeholderId:edit',
  'session:status:DRAFT:set',
  'session:status:WAITING_FOR_REVIEW:set',
  'activity-session:approve',

  '/service-provider/manage/cases:visit',
  '/service-provider/manage/cases/:caseId:visit',
  '/service-provider/manage/cases/consultations:visit',
  '/service-provider/manage/cases/consultations/:consultationId:visit',
  '/service-provider/manage/cases/case-management:visit',
  '/service-provider/manage/cases/case-management/activities/:activityId/configure:visit',
  '/service-provider/manage/cases/case-management/case-id-configuration:visit',
  '/service-provider/manage/cases/case-management/case-details-configuration:visit',
  '/service-provider/manage/cases/case-management/case-summary-configuration:visit',
  '/service-provider/manage/cases/appointments:visit',
  '/service-provider/manage/cases/medication-queue:visit',

  '/service-provider/my-forms:visit',
  '/service-provider/my-forms/:id/:date/capture:visit',
  '/service-provider/my-forms/:id/submissions:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId/calculate:visit',
  '/service-provider/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',

  '/service-provider/my-forms/:id/submissions/submit:visit',

  '/service-provider/manage/admin:visit',
  '/service-provider/manage/admin/create-new:visit',
  '/service-provider/admin/workspaces:visit',
  '/service-provider/admin/workspaces/create-new:visit',
  '/service-provider/admin/workspaces/:workspaceId:visit',
  '/service-provider/admin/workspaces/:workspaceId/overview:visit',
  '/service-provider/admin/workspaces/:workspaceId/overview/datasets/create-new:visit',
  '/service-provider/admin/workspaces/:workspaceId/overview/datasets/:datasetId:visit',
  '/service-provider/admin/workspaces/:workspaceId/overview/forms/create-new:visit',
  '/service-provider/admin/workspaces/:workspaceId/overview/forms/:formId:visit',
  '/service-provider/admin/templates:visit',
  '/service-provider/admin/modules:visit',
  '/service-provider/admin/audittrail:visit',

  '/service-provider/admin/organisations:visit',
  '/service-provider/admin/organisations/:organisationId/users:visit',

  '/service-provider/manage/workspaces:visit',
  '/service-provider/manage/workspaces/create-new:visit',
  '/service-provider/manage/workspaces/:workspaceId:visit',
  '/service-provider/manage/workspaces/:workspaceId/overview:visit',
  '/service-provider/manage/workspaces/:workspaceId/overview/datasets/create-new:visit',
  '/service-provider/manage/workspaces/:workspaceId/overview/datasets/:datasetId:visit',
  '/service-provider/manage/workspaces/:workspaceId/overview/forms/create-new:visit',
  '/service-provider/manage/workspaces/:workspaceId/overview/forms/:formId:visit',

  '/service-provider/manage/activities:visit',
  '/service-provider/manage/activities/:activityId/sessions/:visit',
  '/service-provider/manage/activities/:activityId/sessions/create:visit',
  '/service-provider/manage/activities/:activityId/sessions/:sessionId:visit',
  '/service-provider/manage/activities/:activityId/attendees/:visit',
  '/service-provider/manage/activities/:activityId:visit',
  '/service-provider/manage/activities/create:visit',
  '/service-provider/manage/activities/:stakeholderId:edit',
  '/service-provider/manage/activities/:activityId/assign-users:visit',
  '/service-provider/manage/groups:visit',
  '/service-provider/manage/groups/:groupId/options:visit',
  '/service-provider/manage/services:visit',
  '/service-provider/manage/services/:serviceId:visit',
  '/service-provider/manage/services/create:visit',
  '/service-provider/manage/indicatorFrameworks:visit',
  '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators:visit',
  '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId:visit',
  '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods:visit',
  '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring:visit',
  '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/reporters:visit',
  '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees:visit',
  '/service-provider/manage/indicatorFrameworks/period-groups:visit',
  '/service-provider/manage/indicatorFrameworks/period-groups/:periodGroupId/periods:visit',

  '/service-provider/interventions/period-groups:visit',
  '/service-provider/programmes/period-groups:visit',
  '/service-provider/programmes/period-groups/:periodGroupId/periods:visit',
  '/service-provider/interventions/period-groups/:periodGroupId/configure:visit',

  '/service-provider/manage/indicatorFrameworks/currency-groups:visit',
  '/service-provider/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods:visit',
  '/service-provider/interventions/currency-groups/:currencyGroupId/periods:visit',
  '/service-provider/programmes/currency-groups/:currencyGroupId/periods:visit',
  '/service-provider/interventions/currency-groups:visit',
  '/service-provider/programmes/currency-groups:visit',

  '/service-provider/team-members/:stakeholderId/activities:visit',
  '/service-provider/team-members/:stakeholderId/activities/:activityId/sessions:visit',
  '/service-provider/team-members/:stakeholderId/activities/:activityId/sessions/:sessionId:visit',
  '/service-provider/team-members/:stakeholderId/activities/:activityId/sessions/create:visit',
  '/service-provider/team-members/:stakeholderId/activities/:activityId/attendees:visit',
];

const freeViewerRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/service-provider:visit',
  '/service-provider/my-profile:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',

  '/service-provider/team-members:visit',
  '/service-provider/team-members/create-new:visit',
  '/service-provider/team-members/:teamMemberId:visit',
];

const freeExplorerRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/service-provider:visit',
  '/service-provider/my-profile:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',

  '/service-provider/reports:visit',
  '/service-provider/reports/requirements:visit',
  // '/service-provider/reports/create:visit',
  '/service-provider/reports/create-link:visit',
  '/service-provider/reports/create-report:visit',
  '/service-provider/reports/:reportId:visit',
  '/service-provider/reports/templates:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/templates/:templateId:visit',

  '/service-provider/programmes/portfolios:visit',
  '/service-provider/programmes/:programmeId/sites:visit',
  '/service-provider/programmes/:programmeId/sites/hierarchies:visit',
  '/service-provider/programmes/:programmeId/sites/hierarchies/:hierarchyId:visit',
  '/service-provider/programmes/:programmeId/sites/hierarchies/create:visit',
  '/service-provider/programmes/:programmeId/sites/services:visit',
  '/service-provider/programmes/:programmeId/sites/services/:serviceId:visit',
  '/service-provider/programmes/:programmeId/sites/services/create:visit',
  '/service-provider/programmes/:programmeId/reporters:visit',
  '/service-provider/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/service-provider/programmes:visit',
  '/service-provider/programmes/create:visit',
  '/service-provider/programmes/:programmeId/overview:visit',
  '/service-provider/programmes/:programmeId/indicators:visit',
  '/service-provider/programmes/:programmeId/monitoring:visit',
  '/service-provider/programmes/:programmeId/complete:visit',
  '/service-provider/programmes/interventions:visit',
  '/service-provider/programmes/interventions/create:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/create:visit',
  '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions/cohorts:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/create:visit',
  '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/:cohortId:visit',
  '/service-provider/programmes/interventions/:interventionId/overview:visit',
  '/service-provider/programmes/interventions/:interventionId/indicators:visit',
  '/service-provider/programmes/interventions/:interventionId/inputs:visit',
  '/service-provider/programmes/interventions/:interventionId/activities:visit',
  '/service-provider/programmes/interventions/:interventionId/monitoring:visit',
  '/service-provider/programmes/interventions/:interventionId/complete:visit',
  '/service-provider/programmes/interventions/:interventionId/reporters:visit',
  '/service-provider/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',

  '/service-provider/exports:visit',
  '/service-provider/exports/:workspaceId/questions:visit',
  '/service-provider/exports/:workspaceId/questions/:type/:typeId:visit',
  '/service-provider/exports/profile-data:visit',
  '/service-provider/exports/programme-stats:visit',
  '/service-provider/exports/school-data:visit',

  '/service-provider/manage:visit',
  '/service-provider/manage/insights:visit',
  '/service-provider/manage/insights/create-new:visit',
  '/service-provider/manage/insights/:insightId:visit',
  '/service-provider/manage/insights/:insightId/users:visit',
  '/service-provider/manage/institutions:visit',
  '/service-provider/manage/institutions/sites:visit',
  '/service-provider/manage/institutions/sites/hierarchies:visit',
  '/service-provider/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/service-provider/manage/institutions/sites/hierarchies/create:visit',
  '/service-provider/manage/institutions/sites/services:visit',
  '/service-provider/manage/institutions/sites/services/:serviceId:visit',
  '/service-provider/manage/institutions/sites/services/create:visit',
  '/service-provider/manage/institutions/create:visit',
  '/service-provider/manage/institutions/:institutionId:visit',
  '/service-provider/manage/institutions/cohorts:visit',
  '/service-provider/manage/institutions/cohorts/create:visit',
  '/service-provider/manage/institutions/cohorts/:cohortId:visit',
  '/service-provider/manage/people:visit',
  '/service-provider/manage/people/create:visit',
  '/service-provider/manage/people/addnew:visit',
  '/service-provider/manage/people/:personId:visit',
  '/service-provider/manage/people/cohorts:visit',
  '/service-provider/manage/people/cohorts/create:visit',
  '/service-provider/manage/people/cohorts/:cohortId:visit',

  '/service-provider/my-activities:visit',
  '/service-provider/my-activities/:activityId/sessions/:visit',
  '/service-provider/my-activities/:activityId/sessions/create:visit',
  '/service-provider/my-activities/:activityId/sessions/:sessionId:visit',
  '/service-provider/my-activities/:activityId/attendees/:visit',
  'session:status:DRAFT:set',
  'session:status:WAITING_FOR_REVIEW:set',

  '/service-provider/manage/cases:visit',
  '/service-provider/manage/cases/:caseId:visit',
  '/service-provider/manage/cases/consultations:visit',
  '/service-provider/manage/cases/consultations/:consultationId:visit',
  '/service-provider/manage/cases/case-management:visit',
  '/service-provider/manage/cases/case-management/activities/:activityId/configure:visit',
  '/service-provider/manage/cases/case-management/case-id-configuration:visit',
  '/service-provider/manage/cases/case-management/case-details-configuration:visit',
  '/service-provider/manage/cases/case-management/case-summary-configuration:visit',
  '/service-provider/manage/cases/appointments:visit',
  '/service-provider/manage/cases/medication-queue:visit',

  '/service-provider/my-forms:visit',
  '/service-provider/my-forms/:id/:date/capture:visit',
  '/service-provider/my-forms/:id/submissions:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId/calculate:visit',
  '/service-provider/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',
  '/service-provider/my-forms/:id/submissions/submit:visit',

  '/service-provider/team-members:visit',
  '/service-provider/team-members/create-new:visit',
  '/service-provider/team-members/:teamMemberId:visit',
  '/service-provider/team-members/:teamMemberId/activities:visit',
  '/service-provider/team-members/:stakeholderId/activities:visit',
  '/service-provider/team-members/:stakeholderId/activities/:activityId/sessions:visit',
];

const fullGuestRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/service-provider:visit',
  '/service-provider/my-profile:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',

  '/service-provider/reports:visit',
  '/service-provider/reports/requirements:visit',
  // '/service-provider/reports/create:visit',
  '/service-provider/reports/create-link:visit',
  '/service-provider/reports/create-report:visit',
  '/service-provider/reports/:reportId:visit',
  '/service-provider/reports/templates:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/templates/:templateId:visit',
];

const fieldMemberFreeExplorerRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/service-provider:visit',
  '/service-provider/my-profile:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',

  '/service-provider/reports:visit',
  '/service-provider/reports/requirements:visit',
  // '/service-provider/reports/create:visit',
  '/service-provider/reports/create-link:visit',
  '/service-provider/reports/create-report:visit',
  '/service-provider/reports/:reportId:visit',
  '/service-provider/reports/templates:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/templates/:templateId:visit',

  '/service-provider/my-activities:visit',
  '/service-provider/my-activities/:activityId/sessions/:visit',
  '/service-provider/my-activities/:activityId/sessions/create:visit',
  '/service-provider/my-activities/:activityId/sessions/:sessionId:visit',
  '/service-provider/my-activities/:activityId/attendees/:visit',
  'session:status:DRAFT:set',
  'session:status:WAITING_FOR_REVIEW:set',

  '/service-provider/manage/cases:visit',
  '/service-provider/manage/cases/:caseId:visit',
  '/service-provider/manage/cases/consultations:visit',
  '/service-provider/manage/cases/consultations/:consultationId:visit',
  '/service-provider/manage/cases/case-management:visit',
  '/service-provider/manage/cases/case-management/activities/:activityId/configure:visit',
  '/service-provider/manage/cases/case-management/case-id-configuration:visit',
  '/service-provider/manage/cases/case-management/case-details-configuration:visit',
  '/service-provider/manage/cases/case-management/case-summary-configuration:visit',
  '/service-provider/manage/cases/appointments:visit',
  '/service-provider/manage/cases/medication-queue:visit',

  '/service-provider/my-forms:visit',
  '/service-provider/my-forms/:id/:date/capture:visit',
  '/service-provider/my-forms/:id/submissions:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId/calculate:visit',
  '/service-provider/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',
  '/service-provider/my-forms/:id/submissions/submit:visit',

  '/service-provider/team-members:visit',
  '/service-provider/team-members/create-new:visit',
  '/service-provider/team-members/:teamMemberId:visit',
  '/service-provider/team-members/:teamMemberId/activities:visit',
  '/service-provider/team-members/:stakeholderId/activities:visit',
];

const fieldMemberFullRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/service-provider:visit',
  '/service-provider/my-profile:visit',
  '/service-provider/insights:visit',
  '/service-provider/insights/:insightType/:insightId:visit',

  '/service-provider/reports:visit',
  '/service-provider/reports/requirements:visit',
  // '/service-provider/reports/create:visit',
  '/service-provider/reports/create-link:visit',
  '/service-provider/reports/create-report:visit',
  '/service-provider/reports/:reportId:visit',
  '/service-provider/reports/templates:visit',
  '/service-provider/reports/create-template:visit',
  '/service-provider/reports/templates/:templateId:visit',

  '/service-provider/my-activities:visit',
  '/service-provider/my-activities/:activityId/sessions/:visit',
  '/service-provider/my-activities/:activityId/sessions/create:visit',
  '/service-provider/my-activities/:activityId/sessions/:sessionId:visit',
  '/service-provider/my-activities/:activityId/attendees/:visit',
  'session:status:DRAFT:set',
  'session:status:WAITING_FOR_REVIEW:set',

  '/service-provider/manage/cases:visit',
  '/service-provider/manage/cases/:caseId:visit',
  '/service-provider/manage/cases/consultations:visit',
  '/service-provider/manage/cases/consultations/:consultationId:visit',
  '/service-provider/manage/cases/case-management:visit',
  '/service-provider/manage/cases/case-management/activities/:activityId/configure:visit',
  '/service-provider/manage/cases/case-management/case-id-configuration:visit',
  '/service-provider/manage/cases/case-management/case-details-configuration:visit',
  '/service-provider/manage/cases/case-management/case-summary-configuration:visit',
  '/service-provider/manage/cases/appointments:visit',
  '/service-provider/manage/cases/medication-queue:visit',

  '/service-provider/my-forms:visit',
  '/service-provider/my-forms/:id/:date/capture:visit',
  '/service-provider/my-forms/:id/submissions:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId:visit',
  '/service-provider/my-forms/:id/submissions/:submissionId/calculate:visit',
  '/service-provider/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',
  '/service-provider/my-forms/:id/submissions/submit:visit',

  '/service-provider/team-members:visit',
  '/service-provider/team-members/create-new:visit',
  '/service-provider/team-members/:teamMemberId:visit',
  '/service-provider/team-members/:teamMemberId/activities:visit',
  '/service-provider/team-members/:stakeholderId/activities:visit',
];

export const SERVICE_PROVIDER_OWNER_PLANS = {
  FREE_VIEWER: {
    static: [
      ...freeViewerRoutes,
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: [
      ...freeExplorerRoutes,
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  STANDARD: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
  PREMIUM: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
  ENTERPRISE: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
  BUSINESS: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
};

export const SERVICE_PROVIDER_ADMIN_PLANS = {
  FREE_VIEWER: {
    static: [
      ...freeViewerRoutes,
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: [
      ...freeExplorerRoutes,
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  STANDARD: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
  PREMIUM: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
  ENTERPRISE: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
  BUSINESS: {
    static: [
      ...fullRoutes,
      '/service-provider/manage/dashboards:visit',
      '/service-provider/manage/dashboards/layout/create-new:visit',
      '/service-provider/manage/dashboards/layout/:layoutId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/service-provider/manage/dashboards/metabase:visit',
      '/service-provider/manage/dashboards/metabase/:type/:id:visit',
      '/service-provider/manage/templates:visit',
      '/service-provider/manage/templates/create-new:visit',
      '/service-provider/manage/templates/:templateId:visit',
      '/service-provider/team-members:visit',
      '/service-provider/team-members/create-new:visit',
      '/service-provider/team-members/:teamMemberId:visit',
      '/service-provider/team-members/:teamMemberId/activities:visit',
      '/service-provider/team-members/:stakeholderId/activities:visit',
      '/service-provider/admin:visit',
      '/service-provider/manage/reporting-requirements:visit',
      '/service-provider/manage/reporting-requirements/:requirementId:visit',
      '/service-provider/account:visit',
    ],
  },
};

export const SERVICE_PROVIDER_MEMBER_PLANS = {
  FREE_VIEWER: {
    static: freeViewerRoutes,
  },
  FREE_EXPLORER: {
    static: freeExplorerRoutes,
  },
  STANDARD: {
    static: fullRoutes,
  },
  PREMIUM: {
    static: fullRoutes,
  },
  ENTERPRISE: {
    static: fullRoutes,
  },
  BUSINESS: {
    static: fullRoutes,
  },
};

export const SERVICE_PROVIDER_FIELD_MEMBER_PLANS = {
  FREE_VIEWER: {
    static: freeViewerRoutes,
  },
  FREE_EXPLORER: {
    static: fieldMemberFreeExplorerRoutes,
  },
  STANDARD: {
    static: fieldMemberFullRoutes,
  },
  PREMIUM: {
    static: fieldMemberFullRoutes,
  },
  ENTERPRISE: {
    static: fieldMemberFullRoutes,
  },
  BUSINESS: {
    static: fieldMemberFullRoutes,
  },
};

export const SERVICE_PROVIDER_GUEST_PLANS = {
  FREE_VIEWER: {
    static: [
      '/:visit',
      '/admin/sign-in:visit',
      '/funder/sign-in:visit',
      '/institution/sign-in:visit',
      '/service-provider/sign-in:visit',
      '/forgot-password:visit',

      '/service-provider:visit',
      '/service-provider/my-profile:visit',
      '/service-provider/insights:visit',
      '/service-provider/insights/:insightType/:insightId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: fullGuestRoutes,
  },
  STANDARD: {
    static: fullGuestRoutes,
  },
  PREMIUM: {
    static: fullGuestRoutes,
  },
  ENTERPRISE: {
    static: fullGuestRoutes,
  },
  BUSINESS: {
    static: fullGuestRoutes,
  },
};
